import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type {
  GetJobsRequestActionPayload,
  GetJobsResponseActionPayload,
} from 'client/js/redux/domains/FileIngestor/FileIngestor.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';

const GetJobs = new ReduxAsyncAction<
  'FILE_INGESTOR_GET_JOBS',
  GetJobsRequestActionPayload,
  GetJobsResponseActionPayload | undefined
>('FILE_INGESTOR_GET_JOBS');

GetJobs.registerRequest(async (payload) => {
  try {
    const result = await dash_api.get<GetJobsResponseActionPayload>('/v1/roi/file-ingestor/history', {
      params: payload,
    });

    return result.data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred while fetching jobs list', 'error');
    throw error;
  }
});

export const GET_JOBS = GetJobs.actionNamespaceConstants;

export const getJobs = GetJobs.request;

export type GetJobsResponseAction = Action<typeof GET_JOBS.response> & { data: GetJobsResponseActionPayload };
